import axiosInstance from "../utils/axios";
import { URL } from "../utils/axios";

const API_URL = `${URL}/api/competing-agents`;

// Fetch all competing agents
export const fetchCompetingAgents = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Fetch competing agent by ID
export const fetchCompetingAgentById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create a new competing agent
export const createCompetingAgent = async (agentData) => {
  try {
    const response = await axiosInstance.post(API_URL, agentData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update competing agent
export const updateCompetingAgent = async (id, agentData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${id}`, agentData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete competing agent
export const deleteCompetingAgent = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get agent statistics
export const fetchAgentStatistics = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/statistics/summary`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
